// extracted by mini-css-extract-plugin
export default {"introductionContainer":"IntroductionSectionArea_introductionContainer__pO+U6"};